import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import MobileFixedCta from "./MobileFixedCta";
import SeoManager from "./SeoManager";

/**
 * ページ遷移時のスクロール制御。
 * - ハッシュ付き（/#about など）: 該当セクションへスクロール
 * - ハッシュなし: ページ上部へ
 */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 90);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
    return undefined;
  }, [pathname, hash]);

  return null;
}

export default function SiteLayout() {
  return (
    <>
      <SeoManager />
      <ScrollManager />
      <div className="min-h-screen bg-background-50">
        <SiteHeader />
        <main>
          <Outlet />
        </main>
        <SiteFooter />
        <MobileFixedCta />
      </div>
    </>
  );
}